import React from 'react'
import "./auth.css";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import AuthLogoHeader from "./authLogoHeader";
import SettingsService from '../../services/settings.service';

export default function AboutUS() {
  const { t } = useTranslation();
  const [aboutUs, setAboutUs] = useState([]);

  useEffect(() => {
    getAboutUs();
  }, []);

  const getAboutUs = useCallback(async () => {
    try {
      const response = await SettingsService.getAboutUs();
      if (response.status === 200) {
        setAboutUs(response.data["aboutUs"].split("\n") || []);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <AuthLogoHeader />
      <div className="auth-card-normal">
        <div className="mb-2" align="center">
          <h3 align="center" className="password-text">
            {t("pages.auth_footer.about_us", {
              defaultValue: "About Us",
            })}
          </h3>
          <div style={{ textAlign: "justify", margin: "2rem", fontSize: "16px" }}>
            {aboutUs.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
